// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-tooltip__content.menuable__content__active[data-v-5dc195fe]{opacity:1}", ""]);
// Exports
module.exports = exports;
